<script setup>
export default {
    props: { data: [] },
    methods: {
        async handleViewSalary(elem) {
            this.$emit('handleViewSalary', elem);
        },
        async handleSendSalary(elem) {
            if (elem.payslip) {
                this.$Message.error('Payslip already sent. Cant send additional payslip for the said payroll');
            } else {
                this.$emit('handleSendSalary', elem);
            }
        },
    },
};
</script>

<template>
    <div>
        <Card v-for="elem in data" :key="elem.id" style="width: 100%; margin-top: 20px">
            <!--            <template #title>-->
            <!--&lt;!&ndash;                <Icon type="ios-film-outline"></Icon>&ndash;&gt;-->
            <!--                {{ elem.mainRole }}-->
            <!--            </template>-->
            <template #extra>
                <Row>
                    <Col span="20"> <Icon type="md-eye" size="20" @click="handleViewSalary(elem)" /> </Col>
                    <Col span="20"> <Icon type="md-create" size="20" /> </Col>
                    <Col span="20"> <Icon type="ios-send" size="20" @click="handleSendSalary(elem)" /> </Col>
                </Row>
            </template>

            <Row>
                <Col flex="140px" style="border-right: solid">
                    <Row
                        ><b>{{ elem.name }}</b></Row
                    >
                    <Row>{{ elem.mainRole }}</Row>
                </Col>
                <Col span="3" style="margin-left: 20px">
                    <Row>Total Work Hours</Row>
                    <Row>{{
                        parseInt(elem.computation.hours_worked.regular + elem.computation.hours_worked.sworkholiday)
                    }}</Row>
                </Col>
                <Col span="3"
                    ><Row>Total Absent Hours</Row><Row>{{ parseInt(elem.computation.hours_worked.absent) }}</Row>
                </Col>
                <Col span="3"
                    ><Row>Gross Pay</Row><Row>{{ parseInt(elem.computation.gross_pay) }}</Row>
                </Col>
                <Col span="3"
                    ><Row>Total Contributions</Row>
                    <Row>{{ parseInt(elem.computation.gross_pay) }}</Row>
                </Col>
                <Col span="3"
                    ><Row>Total Deductions</Row> <Row>{{ parseInt(elem.computation.total_deductions) }}</Row></Col
                >
                <Col span="3"
                    ><Row>Total Contributions</Row> <Row>{{ parseInt(elem.computation.total_contributions) }}</Row></Col
                >
                <Col span="3">
                    <Row>Net Pay</Row> <Row>{{ parseInt(elem.computation.net_pay) }}</Row></Col
                >
            </Row>
            <!--            <p>{{ elem.name }}</p>-->
            <!--            <p v-for="item in data" :key="item.id" class="rate-demo">-->
            <!--                <a :href="item.url" target="_blank">{{ item.name }}</a>-->
            <!--                <span><Rate disabled v-model="item.rate" />{{ item.rate }}</span>-->
            <!--            </p>-->
            <p></p>
        </Card>
    </div>
</template>

<style scoped lang="scss"></style>
